import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { link } from 'fs';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'app-modal-skill-tree',
  templateUrl: './modal-skill-tree.component.html',
  styleUrls: ['./modal-skill-tree.component.scss']
})
export class ModalSkillTreeComponent implements OnInit {
  isLoading: boolean = false;
  modalData;
  addNodeForm: FormGroup;
  addLinkForm: FormGroup;
  allActiveNode = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalSkillTreeComponent>,
    public matDialog: MatDialog,
    private fb: FormBuilder
  ) {
    this.modalData = data;
    // // console.log(this.modalData);

    this.addNodeForm = this.fb.group({
      selected: [null],
      input: [null],
    })

    this.addLinkForm = this.fb.group({
      links: this.fb.array([])
      // links: this.fb.array([this.createLinksFormGroup()])
    })
  }

  ngOnInit(): void {
    if (this.modalData.isEdit) {
      this.modalData.availableLevel.map(lv => {
        this.modalData.arrayNode[lv].map(node => {
          this.allActiveNode.push({
            id: node.id,
            label: node.label
          });
        })
      })

      // กดเลือก links ไปแล้ว กดอีกรอบยังไม่นำค่าที่เคยเลือกไว้มาแสดง
      if (this.modalData.links?.length > 4) {
        this.modalData.links.map(link => {
          if (link.source === this.modalData.node.id) {
            this.addLinkForm.get('links')['controls'].push(this.fb.group({
              id: link.id,
              source: link.source,
              target: link.target,
              data: {
                customColor: '#000000'
              }
            }))
          }
        })
      }
      // // console.log(this.allActiveNode);
    }
  }

  selectCourse(e) {
    let select = this.modalData.allCourse.filter(c => c.COURSE_ID === e.target.value);

    this.addNodeForm.patchValue({
      selected: select[0]
    })
    this.addNodeForm.get('selected').updateValueAndValidity()
  }

  selectLink(e, i) {
    let link = this.allActiveNode.filter(c => c.id === e.target.value);

    (<FormArray>this.addLinkForm.get('links')['controls'][i].patchValue({
      id: `${this.modalData.level}-${Math.round(new Date().getTime() / 1000)}`,
      source: this.modalData.node.id,
      target: link[0].id
    }))
    this.addLinkForm.get('links').updateValueAndValidity()
  }


  createNode(form) {
    let str: string;
    if (form.selected && form.input) {
      alert('กรุณาใส่คอร์สเพียง 1 คอร์ส');
    } else {
      if (form.selected) {
        if (form.selected.COURSE_NAME.length > 21)
          str = form.selected.COURSE_NAME.substring(0, 20) + "...";
        else
          str = form.selected.COURSE_NAME

        this.dialogRef.close({
          status: true,
          data: {
            id: form.selected.COURSE_ID,
            label: str,
            tooltip: form.selected.COURSE_NAME,
            data: {
              customColor: "#414A6B",
              customFontColor: "#FFFFFF"
            }
          },
          level: this.modalData.level
        });
      } else if (form.input) {
        if (form.input.length > 21)
          str = form.input.substring(0, 20) + "...";
        else
          str = form.input

        this.dialogRef.close({
          status: true,
          data: {
            id: `informal-${Math.round(new Date().getTime() / 1000)}`,
            label: str,
            tooltip: form.input,
            data: {
              customColor: "#F4F4F4E6",
              customFontColor: "#414A6B"
            }
          },
          level: this.modalData.level
        });
      }
    }
  }

  createLinks(form) {
    form.links.forEach(link => {
      link['data'] = {
        color: '#000000',
        customColor: '#000000'
      }
    });

    this.dialogRef.close({
      status: true,
      data: form.links
    });
  }

  deleteNode() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '450px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'ยืนยันการลบ',
      isDelete: true,
      actionBtnText: 'ลบ',
      cancleBtnText: 'ยกเลิก',
      description: `คุณต้องการลบคอร์สนี้ใช่หรือไม่?`
    }

    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    modal.afterClosed().subscribe(res => {
      if (res) {
        this.dialogRef.close({
          status: true,
          delete: true,
          data: this.modalData.node.id
        });
      }
    })
  }

  createLinksFormGroup() {
    return new FormGroup({
      id: new FormControl('', Validators.required),
      source: new FormControl('', Validators.required),
      target: new FormControl('', Validators.required),
    });
  }

  addNewLinks() {
    let links = this.addLinkForm.get('links') as FormArray;
    links.push(this.createLinksFormGroup());
  }

  removeLink(index) {
    (<FormArray>this.addLinkForm.get("links")).removeAt(index);
  }

  closeModal() {
    this.dialogRef.close(false);
  }
}
